export const defaultDateFormat = "DD.MM.YYYY";
